export default function Slider(theme) {
    return {
        MuiSlider: {
            defaultProps: {
                size: 'small'
            },
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.palette.action.disabled
                    },
                    '&.MuiSlider-sizeMedium': {
                        height: '6px'
                    }
                },
                markLabel: {
                    fontSize: 13,
                    color: theme.palette.text.disabled
                },
                valueLabel: {
                    borderRadius: theme.radius(1),
                    backgroundColor: theme.palette.grey[800],
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.palette.grey[700]
                    })
                }
            }
        }
    };
}
